import React from "react";

const LotusVisionMission = () => {
  return (
    <div className="uvm-section">
      <div className="uvm-container">
        <h2 className="uvm-title">Our Vision & Mission</h2>

        <div className="uvm-grid">

          {/* Vision */}
          <div className="uvm-card vision">
            <div className="uvm-icon-box">🚗</div>
            <h3>Our Vision</h3>
            <p>
              To be the most trusted and preferred cab service by delivering safe, comfortable, and reliable rides for every customer. 
              We aim to redefine city travel by combining convenience, affordability, and professionalism in every journey.
            </p>
            <p>
              Our vision is to set new standards in the transportation industry by focusing on customer satisfaction, expanding our fleet, 
              and continuously enhancing service quality for a seamless travel experience.
            </p>
          </div>

          {/* Mission */}
          <div className="uvm-card mission">
            <div className="uvm-icon-box">🎯</div>
            <h3>Our Mission</h3>
            <p>
              Our mission is to provide hassle-free cab services with well-maintained vehicles and experienced drivers. 
              We are committed to safety, punctuality, and ensuring every ride is smooth, secure, and enjoyable.
            </p>
            <p>
              We strive to build long-term relationships with our customers through transparent pricing, reliable service, 
              and continuous improvements driven by customer feedback and innovation.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LotusVisionMission;